
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import InterviewRequestForm from '@/components/interview/InterviewRequestForm';
import InterviewRequestsTab from '@/components/interview/InterviewRequestsTab';
import SuggestionsTab from '@/components/interview/suggestions/SuggestionsTab';
import EditorialLayout from '@/components/editorial/EditorialLayout';
import { useInterviewTabs } from '@/hooks/interview/useInterviewTabs';
import { useTranslation } from 'react-i18next';

const InterviewRequestsPage: React.FC = () => {
  const { activeTab, setActiveTab, handleRequestSuccess } = useInterviewTabs();
  const { t } = useTranslation();

  return (
    <EditorialLayout>
      <div className="max-w-6xl mx-auto py-8 px-4">
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-6">
          <h1 className="text-3xl font-bold">{t('interview.requests')}</h1>
          <div className="text-gray-600 mt-2 md:mt-0">
            <span>trsekse@gmail.com</span>
          </div>
        </div>
        
        <Tabs value={activeTab} onValueChange={setActiveTab}>
          <TabsList className="mb-8">
            <TabsTrigger value="create">{t('interview.createNew')}</TabsTrigger>
            <TabsTrigger value="manage">{t('interview.manageRequests')}</TabsTrigger>
            <TabsTrigger value="suggestions">{t('interview.suggestions')}</TabsTrigger>
          </TabsList>
          
          <TabsContent value="create">
            <div className="max-w-xl mx-auto">
              <InterviewRequestForm onSuccess={handleRequestSuccess} />
            </div>
          </TabsContent>
          
          <TabsContent value="manage">
            <InterviewRequestsTab onCreateNew={() => setActiveTab('create')} />
          </TabsContent>
          
          <TabsContent value="suggestions">
            <SuggestionsTab />
          </TabsContent>
        </Tabs>
      </div>
    </EditorialLayout>
  );
};

export default InterviewRequestsPage;
